import React from "react";

export const Marquee = ({ items = [], className = "" }) => (
  <div className={`relative overflow-hidden py-6 ${className}`} aria-hidden="true">
    <div className="flex w-max animate-marquee gap-16 whitespace-nowrap">
      {[...items, ...items].map((item, i) => (
        <span
          key={i}
          className="text-2xl sm:text-4xl font-medium tracking-tight text-white/25 flex items-center gap-16"
        >
          {item}
          <span className="h-1.5 w-1.5 rounded-full bg-[#F59E0B]/70" />
        </span>
      ))}
    </div>
  </div>
);
